import { render, staticRenderFns } from "./CleanGover.vue?vue&type=template&id=45bd941d&scoped=true"
import script from "./CleanGover.vue?vue&type=script&lang=js"
export * from "./CleanGover.vue?vue&type=script&lang=js"
import style0 from "./CleanGover.vue?vue&type=style&index=0&id=45bd941d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd941d",
  null
  
)

export default component.exports